module.exports = __webpack_public_path__ + "static/heartChart_Mobile-98ea94876c5b87202fcebf5c5d2070a6.png";